<template>
    <div>
        <nav class="nav">
            <section class="container">
                <section style="display: flex;">
                    <swiper :options="swiperOption1" class='recommend'>
                        <swiper-slide class="recommend-item" v-for="(item,index) in swiper_data" :key="index">
                            <img :src="item.source_url" class="recommend" />
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                    <section style="width: 40.625rem;" v-if="posts_header.length">
                        <div class="swiper-top">{{posts_header[0].title.rendered}}</div>
                        <div class="swiper-bottom" v-html="posts_header[0].content.rendered"></div>
                        <router-link class="details-btn"
                            :to="{ name: 'list-details', query: { id: posts_header[0].id }}">查看详情</router-link>
                    </section>
                </section>
            </section>
        </nav>
        <section class="content container">
            <section class="left1">
                <section class="content-title">
                    <section class="title-left">
                        <div class="tag" :class="active_tag === 'news' ? 'tag1' : 'tag2'" style="cursor: pointer;"
                            @click="active_tag = 'news'">最新动态</div>
                        <div class="tag" :class="active_tag === 'each' ? 'tag1' : 'tag2'" style="cursor: pointer;"
                            @click="active_tag = 'each'">各区动态</div>
                    </section>
                    <router-link :to="{ name: 'list', query: { tag: active_tag }}" class="more-btn">更多 >></router-link>
                </section>
                <section v-if="active_tag === 'news'">
                    <router-link :to="{ name: 'list-details', query: { id: item.id }}" class="content-item"
                        v-for="(item,index) in posts_news" :key="index">
                        <section class="item-left">
                            <img class="icon" src="../../assets/notice-icon.png">
                            <div class="post_title hd">{{item.title.rendered}}</div>
                        </section>
                        <div>{{item.date.split('T')[0]}}</div>
                    </router-link>
                </section>
                <section v-else>
                    <router-link :to="{ name: 'list-details', query: { id: item.id }}" class="content-item"
                        v-for="(item,index) in posts_each" :key="index">
                        <section class="item-left">
                            <img class="icon" src="../../assets/notice-icon.png">
                            <div class="post_title hd">{{item.title.rendered}}</div>
                        </section>
                        <div>{{item.date.split('T')[0]}}</div>
                    </router-link>
                </section>
            </section>
            <section class="right1">
                <section class="right-top">
                    <img src="../../assets/bg.png">
                </section>
                <section class="right-bottom">
                    <router-link :to="{ name: 'list-details', query: { id: item.id }}" class="item-left"
                        style="width: 18.75rem;" v-for="(item,index) in posts_system_info" :key="index">
                        <img class="icon" src="../../assets/icon.png">
                        <div class="hd" style="width: 100%;color: #000000;">{{item.title.rendered}}</div>
                    </router-link>
                </section>
            </section>
        </section>
        <section class="content info container">牢记使命 不忘初心 诚信服务 值得信赖</section>
        <section class="content container" style="padding-bottom: 5.0625rem;">
            <section class="item-width">
                <section class="content-title">
                    <section class="title-left">
                        <div class="tag tag1">工作内容</div>
                    </section>
                    <router-link :to="{ name: 'list', query: { tag: 'work_content' }}" class="more-btn">更多 >>
                    </router-link>
                </section>
                <section>
                    <router-link class="content-item" :to="{ name: 'list-details', query: { id: item.id }}"
                        v-for="(item,index) in posts_work_content" :key="index">
                        <section class="item-left">
                            <img class="icon" src="../../assets/icon.png">
                            <div class="hd" style="width: 35rem;">{{item.title.rendered}}</div>
                        </section>
                    </router-link>
                </section>
            </section>
            <section class="item-width">
                <section class="content-title">
                    <section class="title-left">
                        <div class="tag tag1">政策宣传</div>
                    </section>
                    <router-link :to="{ name: 'list', query: { tag: 'policy_advocacy' }}" class="more-btn">更多 >>
                    </router-link>
                </section>
                <section>
                    <router-link class="content-item" :to="{ name: 'list-details', query: { id: item.id }}"
                        v-for="(item,index) in posts_policy_advocacy" :key="index">
                        <section class="item-left">
                            <img class="icon" src="../../assets/icon.png">
                            <div class="hd" style="width: 35rem;">{{item.title.rendered}}</div>
                        </section>
                    </router-link>
                </section>
            </section>
        </section>
        <section class="info-query">
            <section class="container">
                <section class="title-btn">
                    <router-link class="item-btn" to="/unified-assessment">
                        <div>统一评估</div>
                        <div class="icon-bg"></div>
                    </router-link>
                    <a class="item-btn" href="http://www.shgpo.com/" target="_blank">
                        <div>G P O</div>
                        <div class="icon-bg"></div>
                    </a>
                </section>
                <section class="info-content">
                    <section class="info-title">
                        <div class="new-icon"></div>
                        <div style="font-size: 2.0625rem;">最新消息</div>
                    </section>
                    <section class="info-details">
                        <router-link class="content-item" :to="{ name: 'list-details', query: { id: item.id }}"
                            v-for="(item,index) in posts_latest_news" :key="index">
                            <section class="item-left">
                                <img class="icon" src="../../assets/notice-icon.png">
                                <div class="hd" style="width: 68.75rem;">{{item.title.rendered}}</div>
                            </section>
                            <div>{{item.date.split('T')[0]}}</div>
                        </router-link>
                    </section>
                </section>
            </section>
        </section>
        <section class="special-column container">
            <section class="content-title special-title">
                <section class="special-title-left">
                    <div class="special-icon"></div>
                    <div>专题专栏</div>
                </section>
                <!-- <section class="more-btn">更多 >></section> -->
            </section>
            <section class="swiper-wrap">
                <!-- <swiper ref="mySwiper" :options="swiperOption" style="margin: 0 auto!important;">
                    <swiper-slide v-for="(item,index) in special_column_data" :key="index">
                        <img :src="item.source_url" class="recommend-img" />
                    </swiper-slide>
                </swiper> -->
                <el-carousel :interval="4000" type="card">
                    <el-carousel-item v-for="(item,index) in special_column_data" :key="index" style="display: flex;align-items: center;justify-content: center;">
                        <router-link class="content-item" :to="{ name: 'list-details', query: { id: item.caption.rendered.replace(/[^0-9]/ig,'') }}">
                            <img :src="item.source_url" class="recommend-img" />
                        </router-link>
                    </el-carousel-item>
                </el-carousel>
            </section>
        </section>
    </div>
</template>

<script>
    import {
        Swiper,
        SwiperSlide
    } from 'vue-awesome-swiper';
    import 'swiper/css/swiper.css';
    import axios from 'axios';

    export default {
        name: 'home',
        components: {
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                swiperOption: {
                    loop: true,
                    slidesPerView: 3,
                    autoplay: {
                        delay: 3000,
                    },
                },
                swiperOption1: {
                    loop: true,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                },
                posts_header: [],
                posts_news: [],
                posts_each: [],
                posts_system_info: [],
                posts_work_content: [],
                posts_policy_advocacy: [],
                posts_latest_news: [],
                active_tag: 'news',
                swiper_data: [],
                special_column_data: []
            }
        },
        created() {
            this.swiperData();
            this.postsHeaderList();
            this.postsNewsList();
            this.postsEachList();
            this.postsSystemInfoList();
            this.postsWorkContentList();
            this.postsPolicyAdvocacyList();
            this.postsLatestNewsList();
        },
        methods: {
            swiperData() {
                axios.get('http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/media')
                    .then(response => {
                        const medias = response.data;
                        this.swiper_data = medias.filter((el) => {
                            return el.alt_text === '轮播图';
                        });
                        this.special_column_data = medias.filter((el) => {
                            return el.alt_text === '专题专栏';
                        });
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsHeaderList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=8'
                    )
                    .then(response => {
                        this.posts_header = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsNewsList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=2'
                    )
                    .then(response => {
                        this.posts_news = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsEachList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=3'
                    )
                    .then(response => {
                        this.posts_each = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsSystemInfoList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=4'
                    )
                    .then(response => {
                        this.posts_system_info = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsWorkContentList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=5'
                    )
                    .then(response => {
                        this.posts_work_content = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsPolicyAdvocacyList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=6'
                    )
                    .then(response => {
                        this.posts_policy_advocacy = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
            postsLatestNewsList() {
                axios.get(
                        'http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?per_page=5&categories=7'
                    )
                    .then(response => {
                        this.posts_latest_news = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            },
        }
    }
</script>

<style>
    .nav {
        height: 31.125rem;
        background-color: #BD1A2D;
        overflow: hidden;
    }

    .content {
        display: flex;
        justify-content: space-between;
        margin-top: 2.875rem;
    }

    .left1 {
        width: 58.61875rem;
    }

    .right1 {
        width: 24.915rem;
    }

    .content-title {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        border-bottom: 1px solid #EDEDED;
    }

    .title-left {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-size: 2.0625rem;
    }

    .tag {
        width: 15.0625rem;
        height: 5.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tag1 {
        background-color: #BD1A2D;
    }

    .tag2 {
        background-color: #F3F3F3;
        color: #BD1A2D;
    }

    .more-btn {
        font-size: 1.5625rem;
        color: #BD1A2D;
        cursor: pointer;
    }

    .right-top {
        width: 24.875rem;
        height: 7.75rem;
        margin-bottom: 0.75rem;
        background-color: #FEE4B7;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .right-top img {
        width: 17.5625rem;
        height: 1.6875rem;
    }

    .right-bottom {
        overflow: hidden;
        width: 100%;
        height: 23.375rem;
        background-color: #FBFBFA;
        color: #000000;
        font-size: 1.5625rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }

    .info {
        height: 7.3125rem;
        font-weight: bold;
        justify-content: center;
        align-items: center;
        color: #BD1A2D;
        background-color: #F3F3F3;
        font-family: Adobe Heiti Std;
        font-size: 3.125rem;
    }

    .item-width {
        width: 47%;
    }

    .info-query {
        background-color: #F3F3F3;
        overflow: hidden;
    }

    .title-btn {
        margin-top: 3.1875rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .item-btn {
        cursor: pointer;
        width: 42.875rem;
        height: 6.375rem;
        background-color: #BD1A2D;
        color: #FFFFFF;
        font-size: 2.875rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .icon-bg {
        width: 2.5625rem;
        height: 2.875rem;
        background-image: url(../../assets/icon-bg.png);
        background-size: 100% 100%;
        margin-left: 3.4375rem;
    }

    .info-content {
        margin: 1.25rem auto;
        background-color: #FFFFFF;
        padding-bottom: 0.625rem;
    }

    .special-icon {
        width: 2.875rem;
        height: 2.875rem;
        background-image: url(../../assets/special-icon.png);
        background-size: 100% 100%;
        margin-right: 0.625rem;
    }

    .special-column {
        overflow: hidden;
        margin-top: 0.625rem;
        margin-bottom: 1.25rem;
    }

    .special-title {
        color: #BD1A2D;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: none;
    }

    .special-title-left {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.0625rem;
    }

    .recommend-img {
        width: 23.375rem;
        height: 15rem;
    }

    .recommend {
        width: 47.125rem;
        height: 27.75rem;
        margin-right: 2.25rem;
    }

    .swiper-top {
        font-size: 1.5rem;
        font-family: Adobe Heiti Std;
        color: #FFFFFF;
        line-height: 2em;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .swiper-bottom {
        height: 224px;
        font-size: 1.1rem;
        line-height: 28px;
        font-family: Adobe Heiti Std;
        color: #e3a5aa;
        margin-top: 1.5rem;
        overflow: hidden;
    }
    
    .swiper-bottom p {
        text-indent:2em;
    }

    .swiper-bottom img {
        display: none;
    }

    .swiper-wrap {
        width: 100%;
        padding-left: 2.5rem;
        margin-top: 0.625rem;
    }

    .swiper-pagination-bullet {
        background: #ffffff;
        width: 1.25rem;
        height: 1.25rem;
    }

    .swiper-pagination-bullet-active {
        background: #DBBB84;
        width: 1.25rem;
        height: 1.25rem;
    }

    .swiper-pagination-bullets {
        bottom: 0 !important;
        text-align: right;
    }

    .details-btn {
        font-size: 1.5rem;
        border-bottom: 1px solid #f5d389;
        padding: 0 0 10px 1.875rem;
        cursor: pointer;
        color: #ffffff;
        text-align: right;
        margin-top: 0.625rem;
        float: right;
    }

    .post_title {
        width: 37.5rem;
    }
</style>
